<div class="row sub-change-edit__row">
  <div class="col-12 sub-change-edit__col">
    <app-general-errors class="sub-change-edit__errors" [errors]="errorsArr"></app-general-errors>
    @if (isLoading) {
      <div style="text-align: center;" class="sub-change-edit__loading">
        <app-loading-spinner class="sub-change-edit__spinner"></app-loading-spinner>
      </div>
    }
  </div>
</div>
<mat-stepper linear #stepper [orientation]="(stepperOrientation | async)!" class="sub-change-edit__stepper">
  <!-- Typ, Datum -->
  <mat-step [stepControl]="subChangeTypeForm" editable class="sub-change-edit__step sub-change-edit__step--type">
    <form [formGroup]="subChangeTypeForm" class="mt-3 sub-change-edit__form sub-change-edit__form--type">
      @if (!isMobile) {
        <ng-template matStepLabel>
          <div [innerHTML]="translationService.getTranslation('step_subChangeType')"
               class="sub-change-edit__step-label"></div>
        </ng-template>
      }
      @if (isMobile) {
        <div class="mx-1 sub-change-edit__mobile-label">
          <h2 *appApplyIfNotEmpty="translationService.getTranslation('step_subChangeType')"
              [innerHTML]="translationService.getTranslation('step_subChangeType')"
              class="sub-change-edit__step-title"></h2>
        </div>
      }
      <mat-form-field (click)="picker.open()" formGroupName="validDate"
                      class="sub-change-edit__form-field sub-change-edit__form-field--date">
        <mat-label [innerHTML]="translationService.getTranslation('period')" class="sub-change-edit__label"></mat-label>
        <mat-date-range-input [rangePicker]="picker" [min]="minDate" [max]="maxDate !== currentDate ? maxDate : null"
                              class="sub-change-edit__date-range-input">
          <input matStartDate formControlName="validFrom" readonly placeholder="Startdatum"
                 class="sub-change-edit__input sub-change-edit__input--start">
          <input matEndDate formControlName="validUntil" readonly placeholder="Enddatum"
                 class="sub-change-edit__input sub-change-edit__input--end">
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="picker"
                               class="sub-change-edit__datepicker-toggle"></mat-datepicker-toggle>
        <mat-date-range-picker [touchUi]="isMobile" #picker disabled="false"
                               class="sub-change-edit__date-range-picker"></mat-date-range-picker>
        @if (subChangeTypeForm.get('validDate').hasError('message')) {
          <mat-error class="sub-change-edit__error">
            {{ subChangeTypeForm.get('validDate').getError('message') }}
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field class="sub-change-edit__form-field sub-change-edit__form-field--type">
        <mat-label [innerHTML]="translationService.getTranslation('subchange_type')"
                   class="sub-change-edit__label"></mat-label>
        <mat-select formControlName="changeType" required aria-required="true"
                    [value]="subChangeTypeForm.get('changeType').value" class="sub-change-edit__select">
          @for (subChangeType of subChangeTypes; track subChangeType) {
            <mat-option
              [value]="subChangeType" class="sub-change-edit__option">
              {{ translationService.getTranslation('label_' + subChangeType.code + '_description') }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <div class="sub-change-edit__button-group">
        <button (click)="getPriceForSubChange(stepper)"
                mat-raised-button color="primary" matStepperNext
                [disabled]="!subChangeTypeForm.valid && !subChangeTypeForm.get('validDate').disabled"
                [innerHTML]="translationService.getTranslation('button_next')"
                class="sub-change-edit__button sub-change-edit__button--next">
        </button>
      </div>
    </form>
  </mat-step>

  <!-- Typ:Weiterleitung -->
  @if (subChangeTypeForm.get('changeType').value.code === 'FORWARD') {
    <mat-step [stepControl]="forwardDataForm" editable class="sub-change-edit__step sub-change-edit__step--forward">
      <form [formGroup]="forwardDataForm" class="mt-3 sub-change-edit__form sub-change-edit__form--forward">
        @if (!isMobile) {
          <ng-template matStepLabel>
            <div [innerHTML]="translationService.getTranslation('step_subChangeData')"
                 class="sub-change-edit__step-label"></div>
          </ng-template>
        }
        @if (isMobile) {
          <div class="mx-1 sub-change-edit__mobile-label">
            <h2 *appApplyIfNotEmpty="translationService.getTranslation('step_subChangeData')"
                [innerHTML]="translationService.getTranslation('step_subChangeData')"
                class="sub-change-edit__step-title"></h2>
          </div>
        }
        <app-hup-subscription-address [showActivateCheckbox]="false"
                                      [controlGroup]="forwardDataForm"
                                      class="sub-change-edit__address"></app-hup-subscription-address>
        @if (enableAdditionalExemplar) {
          <mat-checkbox formControlName="additional" class="text-wrap sub-change-edit__checkbox">
            <div [innerHTML]="translationService.getTranslation('subChange_additionalIssue')"
                 class="sub-change-edit__checkbox-label"></div>
          </mat-checkbox>
        }
        <div class="sub-change-edit__button-group">
          <button class="me-3 sub-change-edit__button sub-change-edit__button--back" mat-raised-button
                  matStepperPrevious
                  [innerHTML]="translationService.getTranslation('button_back')"></button>
          @if (!priceCheckFinished || hasFormChanges()) {
            <button
              (click)="getPriceForType(changeable)"
              mat-raised-button color="primary"
              [innerHTML]="translationService.getTranslation('button_check_price')"
              [disabled]="!forwardDataForm.valid"
              class="sub-change-edit__button sub-change-edit__button--check-price"></button>
          }
          @if (priceCheckFinished && !hasFormChanges()) {
            <button
              matStepperNext
              mat-raised-button color="primary"
              [disabled]="isLoading"
              [innerHTML]="translationService.getTranslation('button_next')"
              class="sub-change-edit__button sub-change-edit__button--next"></button>
          }
        </div>
        @if (priceCheckFinished) {
          <div class="row sub-change-edit__row">
            <div class="col-12 sub-change-edit__col">
              @for (warning of warningsArr; track warning) {
                <app-general-warning [warnings]="[{infoText: warning}]"
                                     class="sub-change-edit__warnings"></app-general-warning>
              }
              @if (isLoading) {
                <div style="text-align: center;" class="sub-change-edit__loading">
                  <app-loading-spinner class="sub-change-edit__spinner"></app-loading-spinner>
                </div>
              }
            </div>
          </div>
        }
      </form>
    </mat-step>
  }

  <!-- Typ:Collection -->
  @if (subChangeTypeForm.get('changeType').value.code === 'COLLECT') {
    <mat-step [stepControl]="collectDataForm" editable class="sub-change-edit__step sub-change-edit__step--collect">
      <form [formGroup]="collectDataForm" class="mt-3 sub-change-edit__form sub-change-edit__form--collect">
        @if (!isMobile) {
          <div matStepLabel [innerHTML]="translationService.getTranslation('step_subChangeData')"
               class="sub-change-edit__step-label"></div>
        }
        @if (isMobile) {
          <div class="col-12 mx-1 sub-change-edit__mobile-label">
            <h2 *appApplyIfNotEmpty="translationService.getTranslation('step_subChangeData')"
                [innerHTML]="translationService.getTranslation('step_subChangeData')"
                class="sub-change-edit__step-title"></h2>
          </div>
        }
        TODO: COLLECT
        <div class="sub-change-edit__button-group">
          <button class="me-3 sub-change-edit__button sub-change-edit__button--back" mat-raised-button
                  matStepperPrevious
                  [innerHTML]="translationService.getTranslation('button_back')"></button>
          <button (click)="getPriceForSubChange(stepper)" mat-raised-button color="primary" matStepperNext
                  [innerHTML]="translationService.getTranslation('button_next')"
                  class="sub-change-edit__button sub-change-edit__button--next"></button>
        </div>
      </form>
    </mat-step>
  }

  <!-- Zusammenfassung -->
  <mat-step class="sub-change-edit__step sub-change-edit__step--summary">
    <form [formGroup]="subChangeTypeForm" class="mt-3 sub-change-edit__form sub-change-edit__form--summary">
      @if (saving) {
        <div style="text-align: center;" class="sub-change-edit__loading">
          <app-loading-spinner class="sub-change-edit__spinner"></app-loading-spinner>
        </div>
      }
      @if (!isMobile) {
        <ng-template matStepLabel>
          <div [innerHTML]="translationService.getTranslation('step_summary')"
               class="sub-change-edit__step-label"></div>
        </ng-template>
      }
      @if (isMobile) {
        <div class="col-12 mx-1 sub-change-edit__mobile-label">
          <h2 *appApplyIfNotEmpty="translationService.getTranslation('step_summary')"
              [innerHTML]="translationService.getTranslation('step_summary')" class="sub-change-edit__step-title"></h2>
        </div>
      }

      <h4 *appApplyIfNotEmpty="translationService.getTranslation('step_subChangeType')"
          [innerHTML]="translationService.getTranslation('step_subChangeType')"
          class="sub-change-edit__summary-title"></h4>
      <div class="container-fluid p-0 sub-change-edit__summary-container">
        <div class="row m-0 sub-change-edit__summary-row">
          <div class="col-6 sub-change-edit__summary-label"
               [innerHTML]="translationService.getTranslation('step_subChangeType')"></div>
          <div
            class="col-6 sub-change-edit__summary-value">{{ subChangeTypeForm.get('changeType').value.description }}
          </div>
        </div>
        <div class="row m-0 sub-change-edit__summary-row">
          <div class="col-6 sub-change-edit__summary-label"
               [innerHTML]="translationService.getTranslation('startdate')"></div>
          <div class="col-6 sub-change-edit__summary-value">{{
              subChangeTypeForm.get('validDate.validFrom')?.value | date:
                translationService.getTranslation('dateFormat')
            }}
          </div>
        </div>
        <div class="row m-0 sub-change-edit__summary-row">
          <div class="col-6 sub-change-edit__summary-label"
               [innerHTML]="translationService.getTranslation('enddate')"></div>
          <div class="col-6 sub-change-edit__summary-value">{{
              subChangeTypeForm.get('validDate.validUntil')?.value | date:
                translationService.getTranslation('dateFormat')
            }}
          </div>
        </div>
      </div>
      <mat-divider class="mb-1 mt-3 sub-change-edit__divider"></mat-divider>

      @if (subChangeTypeForm.get('changeType').value.code === 'FORWARD') {
        <h4 *appApplyIfNotEmpty="translationService.getTranslation('step_subChangeData')"
            [innerHTML]="translationService.getTranslation('step_subChangeData')"
            class="sub-change-edit__summary-title"></h4>
        <div class="container-fluid p-0 sub-change-edit__summary-container">
          <div class="row m-0 sub-change-edit__summary-row">
            <div class="col-6 sub-change-edit__summary-label"
                 [innerHTML]="translationService.getTranslation('address_forward')"></div>
            <div class="col-6 sub-change-edit__summary-value">
              <ul class="list-unstyled sub-change-edit__summary-list">
                <li class="sub-change-edit__summary-list-item">
                  {{ forwardDataForm.get('person.salutation').value.description }}
                  {{ forwardDataForm.get('person.title').value.description }}
                  {{ forwardDataForm.get('person.firstName').value }} {{ forwardDataForm.get('person.lastName').value }}
                </li>
                <li class="sub-change-edit__summary-list-item">
                  {{ forwardDataForm.get('address.street').value }} {{ userHouseNo | houseNoPipe }}
                  , {{ forwardDataForm.get('address.extraLine')?.value ? forwardDataForm.get('address.extraLine')?.value + ',' : '' }}
                  {{ forwardDataForm.get('address.zipcode').value }} {{ forwardDataForm.get('address.city').value }}
                  , {{ forwardDataForm.get('address.country').value.description }}
                </li>
              </ul>
            </div>
          </div>
          @if (enableAdditionalExemplar) {
            <div class="row m-0 sub-change-edit__summary-row">
              <div class="col-6 sub-change-edit__summary-label"
                   [innerHTML]="translationService.getTranslation('subchange_additional')"></div>
              <div class="col-6 sub-change-edit__summary-value">
                @if (forwardDataForm.get('additional').value) {
                  <mat-icon class="sub-change-edit__icon sub-change-edit__icon--done">done</mat-icon>
                }
                @if (!forwardDataForm.get('additional').value) {
                  <mat-icon class="sub-change-edit__icon sub-change-edit__icon--clear">clear</mat-icon>
                }
              </div>
            </div>
          }
        </div>
        <div class="row m-0 sub-change-edit__summary-row">
          <!-- Preisinformationen: was kostet die Zustellung?-->
          <div class="col-6 sub-change-edit__summary-label" [innerHTML]="translationService.getTranslation(offerPrice?.credit <= 0.0 ? 'forwarding_summary.new_price' : 'forwarding_summary.credit')">
          </div>

          @if (offerPrice) {
            <div class="col-6 sub-change-edit__summary-value"
                 [innerHTML]="offerPrice?.price && offerPrice?.credit <= 0.0 ? offerPrice.price + ' ' + offerPrice?.currency :
              offerPrice?.credit >= 0.0 ? offerPrice.credit + ' ' + offerPrice.currency : zeroPrice">
            </div>
          } @else {
            <div class="col-6 sub-change-edit__summary-value" [innerHTML]="translationService.getTranslation('forwarding_summary.unknown_price')"></div>
          }
        </div>
      }

      <div class="mt-3 sub-change-edit__button-group">
        <button class="me-3 sub-change-edit__button sub-change-edit__button--back" mat-raised-button matStepperPrevious
                [innerHTML]="translationService.getTranslation('button_back')">
        </button>
        @if (changeable && !isLoading) {
          <button [hidden]="saving" mat-raised-button color="primary"
                  (click)="onSend(stepper)" [innerHTML]="translationService.getTranslation('button_send')"
                  class="sub-change-edit__button sub-change-edit__button--send">
          </button>
        }
      </div>
    </form>
  </mat-step>
</mat-stepper>

<div class="mt-3 float-end sub-change-edit__overview">
  @if (showBackToOverviewButton) {
    <button
      mat-raised-button (click)="backToOverview()"
      [innerHTML]="translationService.getTranslation('button_back_to_overview')"
      class="sub-change-edit__button sub-change-edit__button--overview"></button>
  }
</div>
